module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', {
    attrs: {
      "id": "home-page"
    }
  }, [_c('router-view'), _vm._v(" "), _c('vue-toastr', {
    ref: "toastr"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-990a97bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 518
// module chunks = 1